const styles = {
    modalBackdrop: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    modal: {
        background: 'white',
        borderRadius: 2,
        boxShadow: '0px 11px 15px -7px rgba(0,0,0,0.2), 0px 24px 38px 3px rgba(0,0,0,0.14), 0px 9px 46px 8px rgba(0,0,0,0.12)',
        width: 500,
        maxWidth: '90vw',
        maxHeight: '92vh',
        overflowY: 'auto',
        p: 4,
        outline: 'none',
    },

    modalTitle: {
        fontSize: '20px',
        fontWeight: 600,
        mb: 3,
        color: '#333',
    },
    label: {
        fontSize: "12px",
        fontWeight: "500",
        color: '#000',
        marginBottom: '8px',
    },
    field: {
        width: '100%',
        '& .MuiTypography-root': {
            fontSize: '14px',
            color: '#202020',
            fontWeight: 500,
        },
        '& .MuiOutlinedInput-root': {
            backgroundColor: '#fff',
            '& fieldset': {
                borderColor: '#E0E0E0',
            },
            '&:hover fieldset': {
                borderColor: '#28AA4A',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#28AA4A',
            },
        },
        '& .MuiInputBase-input': {
            fontSize: '14px',
            color: '#202020',
            '&::placeholder': {
                color: '#878787',
                opacity: 1,
            },
        },
    },
    customerSection: {
        marginTop: '22px !important',
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        mb: 3,
        p: 2,
        backgroundColor: '#f8f9fa',
        borderRadius: 1,
    },

    customerAvatar: {
        width: 48,
        height: 48,
        bgcolor: '#e0e0e0',
        borderRadius: '50%',
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundImage: 'url("data:image/svg+xml,%3csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 24 24\' fill=\'%23757575\'%3e%3cpath d=\'M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z\'/%3e%3c/svg%3e")',
        backgroundSize: '24px 24px',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
    },

    customerInfo: {
        flex: 1,
    },

    customerLabel: {
        fontSize: '12px',
        color: '#666',
        mb: 0.5,
        display: 'block',
    },

    customerValue: {
        fontSize: '14px',
        fontWeight: 600,
        color: '#333',
    },

    copyIcon: {
        color: '#ccc',
        fontSize: 16,
        mx: 1,
    },

    creditNoteInfo: {
        minWidth: 120,
    },

    form: {
        mt: 2,
    },

    formRow: {
        display: 'flex',
        gap: 3,
        mt: 2,
        alignItems: 'flex-start',
        '&:first-of-type': {
            mt: 0,
        },
        width: '100%',
    },

    formGroup: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
    },

    formGroupFlex: {
        flex: 1,
        '& .MuiOutlinedInput-root': {
            fontSize: '14px',
        },
    },

    formGroupFixed: {
        flex: 'none',
        width: '50% !important',
    },

    balanceInfo: {
        flex: 'none',
        minWidth: 150,
        textAlign: 'right',
        mt: 1,
    },

    balanceText: {
        color: '#666',
        fontSize: '14px',
        fontWeight: 500,
    },

    requiredText: {
        color: '#d32f2f',
    },

    textField: {
        '& .MuiOutlinedInput-root': {
            fontSize: '14px',
        },
        '& .MuiInputLabel-root': {
            fontSize: '14px',
        },
    },

    inputPrefix: {
        color: '#666',
        fontSize: '14px',
        fontWeight: 500,
        userSelect: 'none',
        pointerEvents: 'none',
    },

    inputLabel: {
        fontSize: '14px',
    },

    selectField: {
        width: '100%',
        fontSize: '14px',
        '& .MuiSelect-select': {
            fontSize: '14px',
        },
    },

    menuItem: {
        fontSize: '14px',
    },

    descriptionField: {
        mt: 2,
        '& .MuiOutlinedInput-root': {
            fontSize: '14px',
        },
        '& .MuiInputLabel-root': {
            fontSize: '14px',
        },
        '& textarea': {
            resize: 'vertical',
            minHeight: '80px',
        },
    },

    modalButtons: {
        mt: 4,
        display: 'flex',
        gap: 2,
    },
    jobButtons: {
        borderRadius: 50,
        textTransform: "none",
        backgroundColor: "#28AA4A",
        fontSize: "14px",
        fontWeight: "500",
        px: 4,
        " & .css-1yt7yx7-MuiLoadingButton-loadingIndicator": {
            position: "unset",
        },
        "& .MuiButton-startIcon": {
            marginRight: "8px",
            marginLeft: "-8px",
        },

    },

    primaryButton: {
        textTransform: 'none',
        fontSize: '14px',
        fontWeight: 500,
        px: 3,
        py: 1.25,
    },

    secondaryButton: {
        textTransform: 'none',
        fontSize: '14px',
        fontWeight: 500,
        px: 3,
        py: 1.25,
    },

    // Responsive styles
    '@media (max-width: 600px)': {
        modal: {
            p: 3,
            width: '95vw',
        },
        formRow: {
            flexDirection: 'column',
            gap: 2,
        },
        formGroupFixed: {
            width: '100%',
        },
        balanceInfo: {
            width: '100%',
            textAlign: 'left',
        },
    },
};

export default styles;